import axios from 'axios';
import { useMutation, useQueryClient } from 'react-query';
import { CreateSubscriptionDto, SubscriptionDto } from '../../model/types';

const SUBSCRIPTION = `/api/admin/subscription`;

interface UpdateTagParams {
	uuid: string;
	request: Partial<CreateSubscriptionDto>;
}

export const useCreateSubscription = () => {
	const queryClient = useQueryClient();
	return useMutation<SubscriptionDto, any, CreateSubscriptionDto>(
		'subscriptions',
		async request => {
			const { data: response } = await axios.post(`${SUBSCRIPTION}/`, request);
			return response;
		},
		{
			onSuccess: () => {
				queryClient.invalidateQueries('subscriptions');
			},
		}
	);
};

export const useUpdateSubscription = () => {
	const queryClient = useQueryClient();
	return useMutation<SubscriptionDto, any, UpdateTagParams>(
		'subscriptions',
		async ({ uuid, request }) => {
			const { data: response } = await axios.patch(
				`${SUBSCRIPTION}/${uuid}`,
				request
			);
			return response;
		},
		{
			onSuccess: () => {
				queryClient.invalidateQueries('subscriptions');
			},
		}
	);
};

export const useDeleteSubscription = () => {
	const queryClient = useQueryClient();
	return useMutation<SubscriptionDto, any, string>(
		'subscriptions',
		async uuid => {
			const { data: response } = await axios.delete(`${SUBSCRIPTION}/${uuid}`);
			return response;
		},
		{
			onSuccess: () => {
				queryClient.invalidateQueries('subscriptions');
			},
		}
	);
};
